import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteContext = createContext({ settings: {}, loading: true });

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/settings")
      .then(({ data }) => setSettings(data || {}))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return <SiteContext.Provider value={{ settings, loading }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
